import Vue from "vue";

Vue.prototype.$globalNav = [
  {
    name: "Home",
    to: "/admin/home",
    icon: "mdi-home-outline"
  },
  {
    name: "現場",
    to: "/admin/site/list",
    icon: "mdi-shovel"
  },
  {
    name: "経費",
    to: "/admin/cost/list",
    icon: "mdi-currency-jpy"
  },
  {
    name: "元請け",
    to: "/admin/contractor/list",
    icon: "mdi-sitemap"
  },
  {
    name: "外注先",
    to: "/admin/partner/list",
    icon: "mdi-domain"
  },
  {
    name: "カテゴリ",
    to: "/admin/category/list",
    icon: "mdi-label"
  },
  {
    name: "担当者",
    to: "/admin/user/list",
    icon: "mdi-account"
  },
  {
    name: "設定",
    to: "/admin/setting",
    icon: "mdi-cog"
  }
];
Vue.prototype.$menuBtn = [
  {
    name: "現場",
    to: "/admin/site/list",
    icon: "mdi-shovel"
  },
  {
    name: "経費",
    to: "/admin/cost/list",
    icon: "mdi-currency-jpy"
  },
  {
    name: "元請け",
    to: "/admin/contractor/list",
    icon: "mdi-sitemap"
  },
  {
    name: "外注先",
    to: "/admin/partner/list",
    icon: "mdi-domain"
  },
  {
    name: "カテゴリ",
    to: "/admin/category/list",
    icon: "mdi-label"
  },
  {
    name: "担当者",
    to: "/admin/user/list",
    icon: "mdi-account"
  },
  {
    name: "設定",
    to: "/admin/setting",
    icon: "mdi-cog"
  },

];

Vue.prototype.$registNav = [
  { name: "経費", to: "/admin/cost/create" },
  { name: "外注先", to: "/admin/partner/create" },
  { name: "担当者", to: "/admin/user/create" },
  { name: "現場", to: "/admin/site/create" }
];

Vue.prototype.$searchNav = [
  { name: "経費", to: "/admin/cost/list" },
  { name: "外注先", to: "/admin/partner/list" },
  { name: "担当者", to: "/admin/user/list" },
  { name: "現場", to: "/admin/site/list" }
];

Vue.prototype.$stages = [
  { id: 1, name: "工事前" },
  { id: 2, name: "足場" },
  { id: 3, name: "工事完了後" },
  { id: 4, name: "その他" },
  { id: 5, name: "追加工事" }
];

Vue.prototype.$globalGeneralNav = [
  {
    name: "Home",
    to: "/site/list",
    icon: "mdi-home-outline"
  }
];
Vue.prototype.$globalCustomerNav = [
  {
    name: "Home",
    to: "/customer/home",
    icon: "mdi-home-outline"
  }
];
